<template>
  <transition name="fade">
    <div v-show="visible" :class="rootClasses">
      <div v-if="showIcon" class="lp-alert-iconbox">
        <lp-icon :box="iconbox" class="lp-alert-icon" :name="iconType" />
      </div>
      <div class="ly-col">
        <p v-if="title" class="lp-alert-title">{{ title }}</p>
        <p
          v-if="
            !defaultSlot &&
            body &&
            (expandable ? (isExpanded ? true : false) : true)
          "
          class="lp-alert-slot"
        >
          {{ body }}
        </p>
        <p
          v-if="
            defaultSlot && (expandable ? (isExpanded ? true : false) : true)
          "
          class="lp-alert-slot"
        >
          <slot />
        </p>
      </div>
      <lp-icon
        v-if="expandable && !isExpanded"
        name="chevron-right"
        class="lp-alert-close"
        @click="toggleIsExpanded"
      />
      <lp-icon
        v-if="expandable && isExpanded"
        name="chevron-down"
        class="lp-alert-close"
        @click="toggleIsExpanded"
      />
      <lp-icon
        v-if="closable && !expandable"
        name="close"
        class="lp-alert-close"
        @click="clickCross"
      />
    </div>
  </transition>
</template>

<script setup lang="ts">
import { computed, ref, useSlots } from 'vue'
import { useCheckSlot } from '@/hooks'
import { ICON_NAME_BY_COLOR, AllowedTypes } from '@/components/alert/constants'
import { Colors } from '@/models/enums'
import { iconType as IconTypes } from '@/components/icon/iconTypes'

defineOptions({
  name: 'lp-alert',
})
interface Props {
  type?: AllowedTypes
  showIcon?: boolean
  closable?: boolean
  expandable?: boolean
  isExpanded?: boolean
  iconbox?: boolean
  visible?: boolean
  title?: string
  body?: string
  icon?: IconTypes | null
}
const props = withDefaults(defineProps<Props>(), {
  type: Colors.PRIMARY,
  showIcon: true,
  closable: false,
  expandable: false,
  isExpanded: false,
  iconbox: false,
  visible: true,
  icon: null,
})

const emit = defineEmits(['on-close'])
const slots = useSlots()
const defaultSlot = useCheckSlot(slots, 'default')

const isExpanded = ref(props.isExpanded)

const toggleIsExpanded = () => (isExpanded.value = !isExpanded.value)
const clickCross = () => emit('on-close')
const iconType = computed(() => props.icon ?? ICON_NAME_BY_COLOR[props.type])
const rootClasses = computed(() => [
  'lp-alert',
  `lp-alert-${props.type}`,
  !props.body && !defaultSlot?.value && 'lp-alert-sm',
])
</script>
